module.exports = __webpack_public_path__ + "static/media/edit.848b676a.svg";